<template>
  <div class="pa-4">
    <div class="text-xs-right pb-4">
      <v-btn icon outline @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="dataCoupon"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>{{ props.item.ref_receipt || '-' }}</td>
          <td>{{ props.item.ref_no || '-' }}</td>
          <td>{{ props.item.store_id || '-' }}</td>
          <td>
            {{ props.item.ref_date ? moment(props.item.ref_date).format('DD/MM/YYYY') : '-' }}
          </td>
          <td>{{ props.item.status | statusWording }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint'

export default {
  props: ['id'],
  data() {
    return {
      headers: [
        { text: 'เลขที่ใบเสร็จ', value: 'ref_receipt' },
        { text: 'Ref.', value: 'ref_no' },
        { text: 'รหัสร้านค้า', value: 'store_id' },
        { text: 'วันที่ในเอกสาร', value: 'ref_date' },
        { text: 'สถานะ', value: 'status' }
      ],
      offset: 0,
      limit: 10,
      dataCoupon: [],
      loading: false
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    }
  },
  methods: {
    async getData() {
      let data = {
        page_id: this.selectedBot.pageid,
        user_id: this.id,
        pageid: this.selectedBot.pageid,
        userid: this.id,
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          console.log(1, data)
          let response = await toaMegapaintApi.getMemberReceipt(data)
          this.dataCoupon = response.data.data
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        api.getMemberReceiptsToaecoupon(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.dataCoupon = response.data
          }
        })
      }
    }
  },
  filters: {
    statusWording(val) {
      let master = [
        { value: 'approved', text: 'อนุมัติ' },
        { value: 'reject', text: 'ไม่อนุมัติ' },
        { value: 'pending', text: 'รอการอนุมัติ' },
        { value: 'waiting_for_delivery', text: 'รอจัดส่ง' }
      ]
      return master.find((f) => f.value == val).text
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/MemberHistoryCoupon.vue